module.exports = __webpack_public_path__ + "img/meet-3.c587f453.jpg";